import { BlocksChip } from 'blocks-nextjs/blocks-web-components/components/chip/chip';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatChip = createComponent({
    react: React,
    tagName: 'cat-chip',
    elementClass: BlocksChip,
    events: {
        onBlChipRemove: 'bl-chip-remove',
        onBlChipSelect: 'bl-chip-select'
    }
});
